import { render } from "./HomepageTopText.vue?vue&type=template&id=99f48df4&scoped=true"
import script from "./HomepageTopText.vue?vue&type=script&lang=js"
export * from "./HomepageTopText.vue?vue&type=script&lang=js"

import "./HomepageTopText.vue?vue&type=style&index=0&id=99f48df4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f48df4"]])

export default __exports__